// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ItHv","select":"styles_select__P5IlY"};